import { Directive, effect, ElementRef, HostListener, input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[re-disable-when-clicked]',
  standalone: false
})
export class DisableWhenClickedDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {

    effect(() => {
      //if bound to some property, lets use that value to disable/enable the button
      if (this.disableWhenClicked()) {
        this.renderer.setAttribute(this.el.nativeElement, 'disabled', "true");
        this.addSpinner();
      }
      else {
        this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
        this.removeSpinner();
      }
    });




  }
  id = `disabledWhenClicked_${(new Date()).valueOf() }`;

  getSpinner() {
    let spanSpinner = document.getElementById(this.id);
    return spanSpinner;
  }
  addSpinner() {
    if (this.getSpinner())
      return;

    const htmlString = `
      <span class="spinner spinner-sm" style="margin-left: 10px; margin-right:20px !important;">
        <span class="lspinner"></span>
      </span>
    `;

    const newElement: HTMLSpanElement = this.renderer.createElement('span');
    newElement.innerHTML = htmlString;
    newElement.id = this.id;

    //this.renderer.insertBefore(this.renderer.parentNode(this.el.nativeElement), newElement, this.renderer.nextSibling(this.el.nativeElement));
    this.renderer.appendChild(this.el.nativeElement, newElement);

  }

  removeSpinner() {
    let spinner = this.getSpinner();
    if (!spinner)
      return;
    this.renderer.removeChild(this.renderer.parentNode, spinner)

  }

  disableWhenClicked = input<boolean>(null, { alias:'re-disable-when-clicked' });

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    //when click the button will be disabled
    this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true');

    this.addSpinner();

  }

}

